import { Link } from 'react-router-dom'
import { useLienClient } from '../contexts/ClientAfficheContext'

export function NotFound() {
  const lien = useLienClient()
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background px-4">
      <h1 className="font-heading text-2xl text-primary mb-4">Page introuvable</h1>
      <p className="font-body text-muted-foreground mb-6">La page que vous cherchez n&apos;existe pas.</p>
      <Link to={lien('/overview')} className="font-body text-accent underline hover:text-primary">
        Retour à l&apos;accueil
      </Link>
    </div>
  )
}
